import HomeView from "../views/HomeView.vue";
import GlobalOffice from "../views/GlobalOffice.vue";
import License from "../views/License.vue";
import GroupIntroduction from "../views/GroupIntroduction.vue";
import BusinessOverview from "../views/BusinessOverview.vue";
import Brokerage from "../views/Brokerage.vue";
import WealthManagement from "../views/WealthManagement.vue";
import PaymentExchange from "../views/PaymentExchange.vue";
import Fintech from "../views/Fintech.vue";
import FinancialEducation from "../views/FinancialEducation.vue";
import Healthcare from "../views/Healthcare.vue";
import ContactUs from "../views/ContactUs.vue";
import DisclosureEmail from "../views/DisclosureEmail.vue";
import Milestone from "../views/Milestone.vue";
import DefaultLayout from "../layout/DefaultLayout.vue";
import ManUtd from "@/views/ManUtd.vue";
import Property from "@/views/Property.vue";
import Consult from "@/views/Consult.vue";
import Cloud from "@/views/Cloud.vue";
import DigitalMarketing from "@/views/DigitalMarketing.vue";
import AUFC from "@/views/AUFC.vue";

export const routes = [
  {
    // EN is the default locale and lives at the root; sc/tc keep their prefix.
    path: "/:lang(sc|tc)?/",
    name: "root",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "home",
        component: HomeView,
      },
      {
        path: "globalOffice",
        name: "globalOffice",
        component: GlobalOffice,
      },
      {
        path: "license",
        name: "license",
        component: License,
      },
      {
        path: "groupIntroduction",
        name: "groupIntroduction",
        component: GroupIntroduction,
      },
      {
        path: "milestone",
        name: "milestone",
        component: Milestone,
      },
      {
        path: "businessoverview",
        name: "businessoverview",
        component: BusinessOverview,
      },
      {
        path: "brokerage",
        name: "brokerage",
        component: Brokerage,
      },
      {
        path: "wealthmanagement",
        name: "wealthmanagement",
        component: WealthManagement,
      },
      {
        path: "paymentexchange",
        name: "paymentexchange",
        component: PaymentExchange,
      },
      {
        path: "fintech",
        name: "fintech",
        component: Fintech,
      },
      {
        path: "financialeducation",
        name: "financialeducation",
        component: FinancialEducation,
      },
      {
        path: "healthcare",
        name: "healthcare",
        component: Healthcare,
      },
      {
        path: "contactus",
        name: "contactus",
        component: ContactUs,
      },
      {
        path: "partnership/manutd/",
        name: "manutd",
        component: ManUtd,
      },
      {
        path: "partnership/aufc/",
        name: "aufc",
        component: AUFC,
      },
      {
        path: "property",
        name: "property",
        component: Property,
      },
      {
        path: "consult",
        name: "consult",
        component: Consult,
      },
      {
        path: "cloud",
        name: "cloud",
        component: Cloud,
      },
      {
        path: "digital-marketing",
        name: "digitalmarketing",
        component: DigitalMarketing,
      },
    ],
  },
  {
    path: "/disclosure/email",
    name: "disclosureEmail",
    component: DisclosureEmail,
  },
  {
    // Legacy /en/* URLs (nginx 301s these in prod; this keeps dev in sync).
    path: "/en/:rest(.*)",
    redirect: (to) => `/${to.params.rest}`,
  },
  {
    path: "/en",
    redirect: "/",
  },
];
